import { Injectable, signal } from '@angular/core';
import { INITIAL_PERCH, SkipperPerch, parsePerch } from '../domain/skipper-perch';

const STORAGE_KEY = 'skipper.perch';

/**
 * Remembers where the user put Skipper, across reloads. Someone who drags
 * Skipper out of the way of a control they use constantly means it, and the
 * tuck is the closest thing to "hide this" — both have to stick.
 *
 * Backed by localStorage and degrades to in-memory when storage is blocked
 * (private mode, disabled cookies), so a read or write can never throw.
 */
@Injectable({ providedIn: 'root' })
export class SkipperCompanionStore {
  private readonly _perch = signal<SkipperPerch>(this.read());
  readonly perch = this._perch.asReadonly();

  save(perch: SkipperPerch): void {
    this._perch.set(perch);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(perch));
    } catch {
      // Storage unavailable — the in-memory perch still holds for this tab.
    }
  }

  /** Tucks Skipper into the edge dock, if out. */
  tuck(): void {
    const current = this._perch();
    if (!current.tucked) this.save({ ...current, tucked: true });
  }

  private read(): SkipperPerch {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return (stored && parsePerch(JSON.parse(stored))) || INITIAL_PERCH;
    } catch {
      return INITIAL_PERCH;
    }
  }
}
